<template>
    <section class="tickets">
        <div class="level m-t-md m-b-md">
            <div class="level-left">
                <div class="level-item">
                    <span class="title">{{id ? 'Edit' : 'Create'}} Topic</span>
                </div>
            </div>
        </div>

        <div class="columns">
            <div class="column">
                <div class="card">
                    <div class="card-content">
                        <div class="columns">
                            <div class="column is-half">
                                <b-field>
                                    <template #label>
                                        Title <span class="has-text-danger">*</span>
                                    </template>
                                    <b-input v-model="data.title"></b-input>
                                </b-field>
                                <b-field>
                                    <template #label>Code</template>
                                    <b-input v-model="data.code"></b-input>
                                </b-field>
                                <b-field v-show="apps.length>1">
                                    <template #label>
                                        Application <span class="has-text-danger">*</span>
                                    </template>
                                    <AppFilter :expanded="true" v-model="data.application_id" :preSelect="data.application_id"/>
                                </b-field>
                                <section class="m-t-md">
                                    <router-link :to="{ name: 'guide' }" class="button is-default m-r-sm">Back</router-link>
                                    <b-button type="is-success m-r-sm" @click.prevent="save">Save</b-button>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Vue from 'vue';
import AppFilter from '../../../../../components/AppFilter.vue'

export default {
    components:{
        AppFilter
    },
    name:"Form",
    data() {
        return {
            data: {
                title: null,
                code: "",
                application_id:null
            },
            apps:[]
        }
    },
    computed: {
        loading: {
            get() {
                return this.$store.state.loading;
            },
            set(value) {
                this.$store.commit("SET_LOADING", value);
            }
        },
        id(){
            return this.$router.currentRoute.params ? this.$router.currentRoute.params.id : null  
        },
    },
    mounted() {
        if(this.id){
            Vue.$topicService.getTopic(this.id).then((response)=>{
                this.data.title = response.data.attributes.title
                this.data.code = response.data.attributes.code
                this.data.application_id = response.data.attributes.application_id
            })
        }
        this.getAppList()
    },
    methods: {
        save() {
            this.loading = true;
            if(!this.id){
                Vue.$topicService.createTopic(this.data).then(()=>{
                    this.$buefy.toast.open({
                        message:"Topic saved!",
                        type:'is-success',
                        isQueue: false
                    });
                    this.$store.commit("SET_ERRORS", null);
                    this.loading = false;
                    this.$router.push({
                        name:'guide'
                    });
                })
                .catch(err => {
                    this.loading = false;
                    console.log(err)
                });
            }else{
                Vue.$topicService.update(this.data,this.id).then(()=>{
                    this.$buefy.toast.open({
                        message:"Topic saved!",
                        type:'is-success',
                        isQueue: false
                    });
                    this.loading = false;
                    this.$router.push({
                        name:'guide'
                    });
                })
                .catch(err => {
                    this.loading = false;
                    console.log(err)
                });
            }
        },
        getAppList() {
            Vue.$appService.appList().then((response)=>{
                this.apps = response
            })
        },
    }
}
</script>